import firebase from 'firebase';
// Required for side-effects
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyAp1DYWS71wbx8lR2l1OZ5aGnjZuFtzRL0',
  authDomain: 'flynnerapp.firebaseapp.com',
  databaseURL: 'https://flynnerapp.firebaseio.com',
  projectId: 'flynnerapp',
};

firebase.initializeApp(config);

// Initialize Cloud Firestore through Firebase
const fs = firebase.firestore();
const db = firebase.database();

export { db, fs };

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase/index.js